import React, { useContext } from "react";
import "./CartItems.css";

import remove_icon from "../Assets/Frontend_Assets/cart_cross_icon.png";
import { ShopContext } from "../../Context/ShopContext";
import { Link } from "react-router-dom";

const CartItems = () => {
  const { getTotalCartAmount, allProducts, cartItems, removeFromCart } =
    useContext(ShopContext);

  // 🔹 Shipping fee
  const SHIPPING_FEE = 4.99;

  if (!allProducts || !cartItems) return <div>Loading cart...</div>;

  // Convert cartItems object to array
  const cartArray = Object.entries(cartItems)
    .filter(([id, qty]) => qty > 0)
    .map(([id, qty]) => {
      const product = allProducts.find((p) => p.id === Number(id));
      if (!product) return null;
      return { ...product, qty };
    })
    .filter(Boolean);

  if (cartArray.length === 0)
    return <div className="cart-empty">Your cart is empty</div>;

  // 🔹 Calculations
  const subtotal = getTotalCartAmount();
  const totalAmount = subtotal + SHIPPING_FEE;

  return (
    <div className="cartitems">
      <div className="cartitems-format-main">
        <p>Product</p>
        <p>Title</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div>
      <hr />

      {cartArray.map((e) => (
        <div key={e.id}>
          <div className="cartitems-format">
            <p className="name">{e.name}</p>
            <p className="price">£{e.new_price}</p>
            <button className="cartitems-quantity">{e.qty}</button>
            <p>£{e.new_price * e.qty}</p>
            <img
              src={remove_icon}
              onClick={() => removeFromCart(e.id)}
              alt="Remove"
            />
          </div>
          <hr />
        </div>
      ))}

      <div className="cartitems-down">
        <div className="cartitems-total">
          <h1>Cart Total</h1>

          <div>
            <div className="cartitems-total-item">
              <p>Subtotal</p>
              <p>£{subtotal}</p>
            </div>
            <hr />

            <div className="cartitems-total-item">
              <p>Shipping</p>
              <p>£{SHIPPING_FEE}</p>
            </div>
            <hr />

            <div className="cartitems-total-item">
              <p>Total</p>
              <p>£{totalAmount}</p>
            </div>
          </div>

          <Link to="/checkout">
            <button>Proceed To Checkout</button>
          </Link>
        </div>

        <div className="cartitems-promocode">
          <p>If you have a promo code, enter it here</p>
          <div className="cartitems-promobox">
            <input type="text" placeholder="Promo Code" />
            <button>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItems;
